export function getMultipleResourcesUrls(allResourceUrls?: { url: string }[]): string[] {
	return (
		// Bug - currently people who don't have permission to content can download the pages
		// they don't have permission to view due to process.env.NEXT_PUBLIC_CONTENT_OVERVIEW_EXPOSE_CONTENT
		// This shouldn't be passed for downloading pages
		allResourceUrls?.map(
			(allResourceUrl) =>
				`${allResourceUrl.url}#${allResourceUrl.url.split('/').pop()?.toLowerCase().split(' ')[0]}` +
				process.env.NEXT_PUBLIC_CONTENT_OVERVIEW_EXPOSE_CONTENT
		) || []
	);
}

export function getContentTitle(currentResourceUrl?: string): string {
	return currentResourceUrl?.split('/').pop()?.toLowerCase().split(' ').join('_') || '';
}
